// @flow

import { getCkuThresholdConfig } from '../components/cluster/cluster-details-inputs/kafka-monthly-inputs-validation';

export const convertConfigArrayToMap = (arr) => {
  const map = new Map();

  for (const elem of arr) {
    map.set(elem.backendFieldName, elem);
  }

  return map;
};

export const getValidationSchemaFromColsConfig = (colsConfig, objectToBePassedInForValidation) => {
  const validationSchemaObj = {};

  for (const col of colsConfig) {
    const backendFieldName = col.backendFieldName;
    const validationConfigured = col.validation;
    validationSchemaObj[backendFieldName] =
      typeof validationConfigured === 'function'
        ? validationConfigured(objectToBePassedInForValidation)
        : validationConfigured;
  }

  return validationSchemaObj;
};

export const createFormNameToFieldsMap = (arr) => {
  const map = new Map();

  for (const elem of arr) {
    const belongingForm = elem.belongingForm;
    const existingValue = map.get(belongingForm);
    if (!existingValue) {
      map.set(belongingForm, []);
    }

    map.get(belongingForm).push(elem);
  }

  return map;
};

export const getIfPartitionsConfiguredAreWithinLimits = (clusterType, metaData, value) => {
  const partitionLimit = getCkuThresholdConfig(metaData, clusterType).partitions_threshold;

  const isError = value > partitionLimit;
  return { partitionLimit, isError };
};
